// extracted by mini-css-extract-plugin
export default {"formContent":"container_formContent__D5112","footer":"container_footer__+xHHA","button":"container_button__VuGHd"};